<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolTransportManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Vehicles",
                description: "Register school vehicles and maintain their details.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Routes",
                description: "Create and manage school transport routes and stops.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Drivers",
                description: "Maintain driver profiles and transport assignments.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Bus Tracking",
                description: "Monitor school bus journeys and route progress.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Transport Fees",
                description: "Set up and review student transport charges.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
